<template>
  <div>
    <div class="login-wrap" v-show="signIn">
      <img class="logo" src="../assets/logo.png" />
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <el-form-item>
          <div
            style="display: flex; flex-direction: column; text-align: center"
          >
            <span class="title_text">品牌申报</span>
          </div>
        </el-form-item>
        <el-form-item prop="account" style="margin-bottom: 15px !important">
          <el-input
            type="text"
            v-model="ruleForm.mobile"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" style="margin-bottom: 15px !important">
          <el-input
            :type="passwordShow"
            show-password
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="请输入密码"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="code"
          class="verification"
          style="margin-bottom: 15px !important"
        >
          <el-input
            type="text"
            v-model="ruleForm.code"
            auto-complete="off"
            placeholder="请输入右侧验证码"
          >
            <span slot="suffix" style="line-height: 76px">
              <img
                style="cursor: pointer; width: 122px"
                :src="image"
                title="验证码点击刷新"
                alt="点击刷新"
                @click="getImg_code"
              />
            </span>
          </el-input>
        </el-form-item>

        <el-form-item class="log_on">
          <el-button
            type="primary"
            class="log_on_but"
            @click="submitForm('ruleForm')"
            :loading="logining"
            >登录
          </el-button>
        </el-form-item>
        <div class="bottom_box">
          <!--          <el-checkbox class="remember" v-model="rememberpwd">自动登录</el-checkbox>-->
          <span
            class="register_class"
            @mouseenter="imgUrlMouseenter"
            @mouseleave="imgUrlMouseleave"
            @click="registerClick"
            >还没有账号，马上注册！</span
          >
          <span class="wjpass" @click="open">忘记密码？</span>
        </div>
        <!--        <el-form-item style="width:100%;margin-bottom:0 !important;margin-top: 25px;">-->
        <!--          <div class="register_class" @mouseenter="imgUrlMouseenter" @mouseleave="imgUrlMouseleave"-->
        <!--               @click="registerClick()">-->
        <!--            用户注册-->
        <!--            <img height="10px" :src="imgUrl" alt="">-->
        <!--          </div>-->
        <!--        </el-form-item>-->
      </el-form>
    </div>
    <!--    注册-->
    <div class="login-wrap" style="padding-top: 2%" v-show="!signIn">
      <img class="logo" src="../assets/logo.png" />

      <el-form
        label-position="left"
        :model="registerForm"
        :rules="registerRules"
        ref="registerRef"
        style="margin: auto; width: 467px"
        class="demo-ruleForm login-container"
      >
        <el-form-item>
          <div
            style="display: flex; flex-direction: column; text-align: center"
          >
            <span
              class=""
              style="
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #000000;
                line-height: 25px;
                line-height: 25px;
              "
              >申报注册</span
            >
            <!--              <div style="border-bottom: 3px solid #E40080;width: 50px;"></div>-->
          </div>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input
            type="text"
            v-model="registerForm.name"
            auto-complete="off"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司" prop="company">
          <el-input
            type="text"
            v-model="registerForm.company"
            auto-complete="off"
            placeholder="请输入公司"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            type="text"
            v-model="registerForm.email"
            auto-complete="off"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            type="text"
            v-model="registerForm.mobile"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <!--          <el-form-item label="图片验证码" prop="img_code" class="verification">-->
        <!--            <el-input type="text" v-model="registerForm.img_code" auto-complete="off"-->
        <!--                      placeholder="请输入右侧验证码">-->
        <!--          <span slot="suffix" style="line-height:76px">-->
        <!--                      <img style="cursor: pointer; width: 122px;" :src="image" title="验证码点击刷新"-->
        <!--                           alt="点击刷新" @click="getImg_code"/>-->
        <!--                      </span>-->

        <!--            </el-input>-->
        <!--          </el-form-item>-->
        <el-form-item label="手机验证码" prop="sms_code" class="verification">
          <el-input
            type="text"
            v-model="registerForm.sms_code"
            auto-complete="off"
            placeholder="请输入验证码"
          >
            <span slot="suffix">
              <span
                style="
                  font-weight: 400;
                  font-size: 14px;
                  color: #1677ff;
                  cursor: pointer;
                "
                v-if="countdown == 60"
                @click="getFlag('DR', registerForm)"
                >获取验证码</span
              >
              <span v-else style="font-weight: 400; font-size: 14px"
                >已发送（{{ countdown }}s）</span
              >
            </span>
          </el-input>
          <!--              <el-button type="info" style="border: none;border-radius: 8px;margin-left: 10px">获取验证码</el-button>-->
        </el-form-item>
        <el-input
          type="text"
          v-model="password"
          auto-complete="off"
          placeholder="请输入密码"
          style="position: absolute; z-index: -9999999; width: 20px"
        >
        </el-input>
        <el-input
          :type="passwordShow"
          show-password
          v-model="password"
          auto-complete="off"
          placeholder="请输入密码"
          style="position: absolute; z-index: -9999999; width: 20px"
        >
        </el-input>

        <el-form-item label="密码" prop="password">
          <el-input
            :type="passwordShow"
            show-password
            v-model="registerForm.password"
            auto-complete="off"
            placeholder="请输入密码"
          >
          </el-input>
        </el-form-item>
        <!--          <el-form-item prop="password_confirm">-->
        <!--            <el-input :type="passwordShow" show-password v-model="registerForm.password_confirm" auto-complete="off"-->
        <!--                      placeholder="请再次输入密码">-->
        <!--            </el-input>-->
        <!--          </el-form-item>-->
        <el-form-item prop="agree" style="margin: 15px 0 30px 0">
          <el-checkbox style="color: #a9abba" v-model="agree"
            >我已阅读并同意《用户协议》和《隐私协议》
          </el-checkbox>
        </el-form-item>

        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="
              width: 100%;
              background: #e40080;
              border: #e40080;
              height: 52px;
            "
            @click="RegisterAnAccount('registerRef')"
            :loading="logining"
            >注册
          </el-button>
        </el-form-item>
        <el-form-item style="width: 100%">
          <div
            class="register_class"
            style="text-align: center"
            @mouseenter="imgUrlMouseenter"
            @mouseleave="imgUrlMouseleave"
            @click="registerClick"
          >
            已有账号？去登录
          </div>
        </el-form-item>
      </el-form>
      <!--      <div class="login-wrap_content">-->
      <!--      </div>-->
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="忘记密码"
      :visible.sync="dialogVisible"
      width="440px"
    >
      <el-form
        :model="forget_form"
        :rules="forget_form_rules"
        ref="forget_form_ref"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input
            type="text"
            v-model="forget_form.mobile"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <!--        <el-form-item prop="img_code" class="verification">-->
        <!--          <el-input type="text" v-model="forget_form.img_code" auto-complete="off"-->
        <!--                    placeholder="请输入右侧验证码">-->
        <!--           <span slot="suffix" style="line-height:76px">-->
        <!--                      <img style="cursor: pointer; width: 122px;" :src="image" title="验证码点击刷新"-->
        <!--                           alt="点击刷新" @click="getImg_code"/>-->
        <!--                      </span>-->
        <!--          </el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="验证码" prop="sms_code" class="verification">
          <el-input
            type="text"
            v-model="forget_form.sms_code"
            auto-complete="off"
            placeholder="请输入验证码"
          >
            <span slot="suffix">
              <span
                style="
                  font-weight: 400;
                  font-size: 14px;
                  color: #1677ff;
                  cursor: pointer;
                "
                v-if="countdown == 60"
                @click="getFlag('DRZH', forget_form)"
                >获取验证码</span
              >
              <span v-else style="font-weight: 400; font-size: 14px"
                >已发送（{{ countdown }}s）</span
              >
            </span>
          </el-input>
        </el-form-item>
        <el-input
          type="text"
          v-model="password"
          auto-complete="off"
          placeholder="请输入密码"
          style="position: absolute; width: 10px; z-index: -9999999"
        >
        </el-input>
        <el-input
          :type="passwordShow"
          show-password
          v-model="password"
          auto-complete="off"
          placeholder="请输入密码"
          style="position: absolute; width: 10px; z-index: -9999999"
        >
        </el-input>
        <el-form-item label="设置密码" prop="password">
          <el-input
            :type="passwordShow"
            show-password
            v-model="forget_form.password"
            auto-complete="off"
            placeholder="请设置密码"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password_confirm">
          <el-input
            :type="passwordShow"
            show-password
            v-model="forget_form.password_confirm"
            auto-complete="off"
            placeholder="请确认密码"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          :disabled="logining"
          type="primary"
          @click="forgotPasswd('forget_form_ref')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  getVerify,
  getPhoneCode,
  getmyMenu,
  register,
  SignInaccount,
  Login_sendCode,
  Login_forgotPasswd,
} from "@/api/api";
import { setCookie, getCookie, delCookie } from "../utils/util";
import { Message } from "element-ui";

export default {
  name: "login",
  data() {
    return {
      forget_form: {},
      image: "",
      img_code_dis: false,
      password: "",
      signIn: true,
      passwordShow: "password",
      password_flag: false,
      imgUrl: require("../assets/right.png"),
      dialogVisible: false,
      //定义loading默认为false

      logining: false,
      // 记住密码
      rememberpwd: false,
      // 同意
      agree: false,
      ccompanyList: [],
      // 注册
      registerForm: {
        password: "",
        channel: "10", //1-微信小程序 2-微信公众号 3-手机H5 4-电脑PC 5-苹果APP 6-安卓APP 7-百度推广 8-SoSee推广 9-测试 10申报
        // password_confirm: '',
        sms_code: "",
        img_code: "",

        name: "",
        company: "",
        mobile: "",
        email: "",
        scene: "",
      },
      // 登录
      ruleForm: {
        code: "",
        scene: "1",
        mobile: "",
        password: "",
        terminal: 10,
      },
      countdown: 60,
      // 注册验证
      registerRules: {
        sms_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password_confirm: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ],
        committee_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        type: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
      },

      //rules前端验证
      rules: {
        // account: [
        //   { required: true, message: "请输入手机号", trigger: "blur" },
        //   {
        //     pattern: /^1[3-9]\d{9}$/,
        //     message: "手机号码格式不正确",
        //     trigger: "blur",
        //   },
        // ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      forget_form_rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        sms_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password_confirm: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    this.getImg_code();
    // 获取存在本地的用户名密码
    this.getuserpwd();
    //获取分会列表
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    imgUrlMouseenter() {
      this.imgUrl = require("../assets/right_pink.png");
    },
    imgUrlMouseleave() {
      this.imgUrl = require("../assets/right.png");
    },
    getImg_code() {
      getVerify().then((res) => {
        if (res.code == 1) {
          this.image = res.data.img;
        } else {
          Message.error(res.msg);
        }
      });
    },
    forgotPasswd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          let params = this.forget_form;
          params.scene = "DRZH";
          Login_forgotPasswd(params)
            .then((res) => {
              this.logining = false;
              if (res.code == 1) {
                this.forget_form = {};
                Message.success(res.msg);
                this.dialogVisible = false;
              }
            })
            .catch((err) => {
              this.logining = false;
              console.log(err);
            });
        }
      });
    },

    getFlag(scene, form) {
      // if (form.account.length > 0 && form.img_code.length > 0) {

      let data = {
        scene: scene,
        // img_code: form.img_code,
        mobile: form.mobile,
      };
      Login_sendCode(data).then((res) => {
        if (res.code == 1) {
          Message.success("验证码发送成功，请注意查收");
          this.timer();
        } else {
          this.forget_form.img_code = "";
          this.registerForm.img_code = "";
          // this.getImg_code()
        }
      });
      // } else {
      //   Message.error('请填写手机号及图片验证码');
      // }
    },
    // 计时器
    timer() {
      if (this.countdown < 0) {
        this.countdown = 60;
        return;
      }
      setTimeout(() => {
        this.countdown = this.countdown - 1;
        this.timer();
      }, 1000);
    },

    registerClick() {
      this.signIn = !this.signIn;
      // if (!this.signIn) this.GetccompanyType()
    },
    // 注册
    RegisterAnAccount(formName) {
      if (!this.agree)
        return Message.warning("请阅读并同意《用户协议》和《隐私协议》");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          let params = this.registerForm;
          params.scene = "DR";
          register(params)
            .then((res) => {
              this.logining = false;
              if (res.code == 1) {
                this.registerForm = {};
                Message.success(res.msg);
                this.registerClick();
              }
            })
            .catch((err) => {
              this.logining = false;
              console.log(err);
            });
        }
      });
    },

    // 获取用户名密码
    getuserpwd() {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.ruleForm.account = getCookie("user");
        this.ruleForm.password = getCookie("pwd");
        this.rememberpwd = true;
      }
    },
    jsonToFormData(json) {
      const formData = new FormData();
      for (let key in json) {
        formData.append(key, json[key]);
      }
      return formData;
    },
    //登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          //this.$store.dispatch("userLogin", false);
          localStorage.removeItem("Flag");
          let params = this.ruleForm;
          SignInaccount(params)
            .then((res) => {
              if (res.code == 1) {
                // this.GetccompanyType(this.ruleForm.type)
                let loginRes = {
                  token: res.data.token,
                  isLogin: true,
                };
                this.$store.commit("userStatus", loginRes);
                localStorage.setItem("Flag", "isLogin");
                // 缓存token 用户个人信息
                localStorage.setItem("userdata", JSON.stringify(res.data));
                if (this.rememberpwd) {
                  //保存帐号到cookie，有效期7天
                  setCookie("user", this.ruleForm.account, 7);
                  //保存密码到cookie，有效期7天
                  setCookie("pwd", this.ruleForm.password, 7);
                } else {
                  delCookie("user");
                  delCookie("pwd");
                }
                // this.getconfigdict()
                // this.getPhoneCode()
                this.getmyMenu();
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.logining = false;
                  this.$router.push({
                    path: "/home",
                  });
                }, 1000);
              } else {
                this.getImg_code();
                this.$message.warning(res.data.msg);
                this.logining = false;
                return false;
              }
            })
            .catch((err) => {
              this.logining = false;
            });
        } else {
          // 获取图形验证码
          this.getImg_code();
          this.$message.error("请输入用户名密码以及验证码！");
          this.logining = false;
          return false;
        }
      });
    },
    // 获取左侧菜单
    getmyMenu() {
      let data = this.$qs.stringify({ client_mark: "declare" });
      getmyMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let { data } = res;
            this.$store.commit("menuStatus", JSON.stringify(data));
            localStorage.setItem("menu", JSON.stringify(data));
          }
        })
        .catch((err) => {
          console.log(err);
          // if (err.response.data.code == 401) {
          //   this.$router.push({
          //     path: "/login",
          //   });
          // }
        });
    },

    // 获取区号
    getPhoneCode() {
      getPhoneCode({})
        .then((res) => {
          if (res.code == 1) {
            localStorage.setItem("codedata", JSON.stringify(res.data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  //margin-left: 50%;
  //min-height: 420px;
}

.dialog_box {
  font-size: 16px;
  font-weight: bold;
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  padding-top: 10%;
  box-sizing: border-box;
  background-image: url("../assets/loginbg.jpg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;
}

.logo {
  position: absolute;
  width: 218px;
  top: 80px;
  left: 80px;
  z-index: -1;
}

.login-wrap_content {
  width: 1020px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.login-container {
  max-height: 100%;
  overflow: auto;
  border-radius: 10px;
  margin: 0px auto;
  width: 467px;
  padding: 30px 40px 50px;
  box-sizing: border-box;
  background: #fff;
  // border: 1px solid #eaeaea;
  // text-align: left;
  // box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
  line-height: 25px;
  text-align: center;
  font-style: normal;
  margin-bottom: 30px;
}

.remember {
  color: #a9abba;
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}

.bottom_box {
  display: flex;
  justify-content: space-between;
}

.wjpass {
  font-weight: 400;
  font-size: 14px;
  color: #a9abba;
  //line-height: 22px;
  cursor: pointer;
}

@media only screen and (max-width: 767px) {
  .login-wrap {
    display: flex;
    align-items: center;
    background-size: 100% 100%;
  }

  .login-container {
    width: 70%;
  }
}

.icon_see {
  background-image: url("../assets/see.png");
}

.icon_close {
  background-image: url("../assets/nosee.png");
}

.log_on {
  width: 100%;
}

.log_on_but {
  width: 100%;
  background: #e40080;
  border: #e40080;
  height: 52px;
  margin: 30px 0 20px 0;
}

.register_class:hover {
  color: #e40080;
}

.register_class {
  font-weight: 400;
  font-size: 14px;
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-tabs__header {
  display: flex;
  justify-content: center;
}

/deep/ .el-tab-pane {
  display: none;
}

/deep/ .el-tabs__active-bar {
  background-color: #e40080;
}

/deep/ .is-active {
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}

/deep/ .el-input__inner {
  height: 46px;
}

//.verification /deep/ .el-form-item__content {
//  display: flex;
//}

/deep/ .el-form-item {
  margin-bottom: 0px !important;
}

/deep/ .el-form-item__error {
  font-size: 10px !important;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

/deep/ .el-form-item__label {
  font-size: 14px;
  color: #555;
  height: 30px;
  margin-bottom: 5px;
}

/deep/ .el-dialog__header {
  text-align: center;
}
</style>